<template>
  <v-dialog
    v-model="dialogAtivo"
    width="50em"
    lazy
    :fullscreen="$vuetify.breakpoint.xs"
    hide-overlay
    scrollable
    @click:outside="
        dialogAtivo = false
    "
    @keydown.esc="
        dialogAtivo = false
    "
  >
  <v-tooltip bottom slot="activator">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                flat
                color='info'
                v-bind="attrs"
                v-on="on"
            >
                <v-icon>receipt_long</v-icon>
            </v-btn>
        </template>
        <h3>Faturas</h3>
    </v-tooltip>
    <v-card class="ma-0 pa-0">
        <v-card-title class="justify-center">
            <v-btn
                icon
                color="info"
                @click="step = 1, faturaSelecionada = undefined"
                v-if="step > 1"
                style="
                    position: absolute;
                    left: 1.5em;
                "
            >
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <h1>{{ titulo }}</h1>
            <v-btn
                icon
                color="info"
                @click="step = 2"
                v-if="step === 1"
                style="
                    position: absolute;
                    right: 1.5em;
                "
            >
                <v-icon>add</v-icon>
            </v-btn>
        </v-card-title>
        <v-alert v-show="alerta" :type="tipo" style="width: 100%;" class="pa-2" :value="true">
            <h4>{{alerta}}</h4>
        </v-alert>
        <v-divider v-show="alerta"></v-divider>
        <v-card-text>
            <v-stepper v-model="step" style="box-shadow: none;" class="ma-0 pa-0">
                <v-stepper-items>
                    <v-stepper-content step="1" class="justify-center ma-0 pa-0">
                        <v-list class="mb-4" v-if="faturas.length > 0 && !loading">
                            <v-list-tile v-for="(fatura, index) in faturas" :key="index">
                                <v-list-tile-avatar>
                                    <v-icon color="info">receipt_long</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        Referente a {{ fatura.data_fatura | formatDate('DD/MM/YYYY')  }}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title>
                                        {{ fatura.valor_faturamento | currency({ fractionCount: 2 }) }}
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action class="justify-space-around d-inline">
                                    <v-tooltip bottom>
                                        <v-btn
                                            slot="activator"
                                            icon
                                            class="mr-2"
                                            @click="faturaSelecionada = fatura, step = 3"
                                        >
                                            <v-icon color="primary">remove_red_eye</v-icon>
                                        </v-btn>
                                        <span>Ver Detalhes</span>
                                    </v-tooltip>
                                    <v-menu
                                        offset-y
                                        full-width
                                        lazy
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-on="on"
                                                icon
                                                class="mr-2"
                                            >
                                                <v-icon color="error">delete</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-title class="error white--text justify-center">
                                                <h4>DELETAR FATURA</h4>
                                            </v-card-title>
                                            <v-card-text>
                                                Tem certeza que você deseja deletar essa fatura
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-flex xs6>
                                                    <v-btn
                                                        block
                                                        flat
                                                    >NÃO</v-btn>
                                                </v-flex>
                                                <v-divider vertical></v-divider>
                                                <v-flex xs6>
                                                    <v-btn
                                                        block
                                                        flat
                                                        color="error"
                                                        :disabled="loading"
                                                        :loading="loading"
                                                        @click="deletarFatura(fatura)"
                                                    >SIM</v-btn>
                                                </v-flex>
                                            </v-card-actions>
                                        </v-card>
                                    </v-menu>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                        <h4 v-else-if="!loading" class="text-xs-center gray--text ma-4">AINDA NÃO HÁ FATURAS GERADAS</h4>
                        <v-layout justify-center v-else>
                            <v-progress-circular
                                indeterminate
                                :size="200"
                                color="info"
                            ></v-progress-circular>
                        </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="2" class="justify-center ma-0 pa-0">
                        <v-layout wrap justify-space-around class="mb-4">
                            <template v-if="eh_automatico">
                                <v-flex xs5 class="pb-0 ma-0">
                                    <v-menu
                                        ref="menuDataFatura"
                                        v-model="menuDataFatura"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        class="pa-0 ma-0"
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                label="Data Início"
                                                :value="`${data_inicio ? data_inicio.split('-').reverse().join('/') : ''}`"
                                                required
                                                outline
                                                readonly
                                                v-on="on"
                                                :rules="[
                                                    (v) => !!v || 'A data da fatura é obrigatória'
                                                ]"
                                                class="pa-0 ma-0"
                                                style="width: 100%;"
                                            />
                                        </template>
                                            <v-date-picker
                                                v-model="data_inicio"
                                                locale="pt-br"
                                                color="info"
                                                class="mb-4"
                                                no-title
                                                @input="menuDataFatura = false"
                                            ></v-date-picker>
                                        </v-menu>
                                </v-flex>
                                <v-flex xs5 class="pb-0 ma-0">
                                    <v-menu
                                        ref="menuDataFim"
                                        v-model="menuDataFim"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        class="pa-0 ma-0"
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                label="Data Fim"
                                                :value="`${data_fim ? data_fim.split('-').reverse().join('/') : ''}`"
                                                required
                                                outline
                                                readonly
                                                v-on="on"
                                                :rules="[
                                                    (v) => !!v || 'A data da fatura é obrigatória'
                                                ]"
                                                class="pa-0 ma-0"
                                                style="width: 100%;"
                                            />
                                        </template>
                                            <v-date-picker
                                                v-model="data_fim"
                                                locale="pt-br"
                                                color="info"
                                                class="mb-4"
                                                no-title
                                                @input="menuDataFim = false"
                                            ></v-date-picker>
                                        </v-menu>
                                </v-flex>
                            </template>
                            <template v-else>
                                <v-flex xs5 class="pb-0 ma-0">
                                    <v-menu
                                        ref="menuDataFatura"
                                        v-model="menuDataFatura"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        class="pa-0 ma-0"
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                label="Data Início"
                                                :value="`${data_inicio ? data_inicio.split('-').reverse().join('/') : ''}`"
                                                required
                                                outline
                                                readonly
                                                v-on="on"
                                                :rules="[
                                                    (v) => !!v || 'A data da fatura é obrigatória'
                                                ]"
                                                class="pa-0 ma-0"
                                                style="width: 100%;"
                                            />
                                        </template>
                                            <v-date-picker
                                                v-model="data_inicio"
                                                locale="pt-br"
                                                color="info"
                                                class="mb-4"
                                                no-title
                                                @input="menuDataFatura = false"
                                            ></v-date-picker>
                                        </v-menu>
                                </v-flex>
                                <v-flex xs5 class="pb-0 ma-0">
                                    <v-menu
                                        ref="menuDataFim"
                                        v-model="menuDataFim"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        class="pa-0 ma-0"
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                label="Data fim"
                                                :value="`${data_fim ? data_fim.split('-').reverse().join('/') : ''}`"
                                                required
                                                outline
                                                readonly
                                                v-on="on"
                                                :rules="[
                                                    (v) => !!v || 'A data da fatura é obrigatória'
                                                ]"
                                                class="pa-0 ma-0"
                                                style="width: 100%;"
                                            />
                                        </template>
                                            <v-date-picker
                                                v-model="data_fim"
                                                locale="pt-br"
                                                color="info"
                                                class="mb-4"
                                                no-title
                                                @input="menuDataFim = false"
                                            ></v-date-picker>
                                        </v-menu>
                                </v-flex>
                                <v-flex xs11>
                                    <v-text-field
                                        label="Valor total da fatura"
                                        outline
                                        v-money="money"
                                        prefix="R$"
                                        v-model.lazy="valor_total"
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 class="ma-4">
                                    <v-divider></v-divider>
                                </v-flex>
                                <v-flex xs5>
                                    <v-select
                                        single-line
                                        :items="combustiveis"
                                        item-text="nome"
                                        item-value="id_combustivel"
                                        v-model="combustivelSelecionado"
                                        return-object
                                        outline
                                        placeholder="Selecione um combustível"
                                        clearable
                                        hint="Combustível referente ao tipo de faturamento"
                                    />
                                </v-flex>
                                <v-flex xs5>
                                    <v-text-field
                                        label="Quantidade Vendida"
                                        outline
                                        v-model="qtd_vendida"
                                        type="number"
                                        hint="Quantidade de combustível vendido"
                                    ></v-text-field>
                                    <h5 v-if="qtd_sugerida" class="mb-3">Quantidade sugerida {{ qtd_sugerida | currency({ fractionCount: 2 }) }}</h5>
                                </v-flex>
                                <v-flex xs11 v-if="combustivelSelecionado">
                                    <v-text-field
                                        :label="`Valor de ${combustivelSelecionado.nome}`"
                                        outline
                                        v-model="valor_vendas_combustivel"
                                        v-money="money"
                                        prefix="R$"
                                        :hint="`Valor total de ${combustivelSelecionado.nome} vendido`"
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs11>
                                    <v-text-field
                                        :label="'Valor de taxa'"
                                        outline
                                        v-model="valor_taxa"
                                        v-money="money"
                                        prefix="R$"
                                        hint="Valor total da taxa cobrada ao posto"
                                    >
                                    </v-text-field>
                                    <h5 v-if="valor_taxa_sugerido" class="mb-3">valor sugerido {{ valor_taxa_sugerido | currency({ fractionCount: 2 }) }}</h5>
                                </v-flex>
                                <v-flex xs11>
                                    <v-text-field
                                        label="Descrição"
                                        outline
                                        v-model="descricao"
                                        hint="Digite um descrição para esse tipo de faturamento"
                                    ></v-text-field>
                                </v-flex>
                                <v-btn
                                    color="info"
                                    class="mb-4"
                                    @click="adicionarTipoFaturamento"
                                    style="width: 100%;"
                                    flat
                                >
                                    <v-icon>add</v-icon>
                                    Adicionar tipo de faturamento
                                </v-btn>
                                <h2
                                    v-if="tipos_faturamento.length >  0"
                                >
                                    Tipos de faturamento
                                </h2>
                                <v-list class="ma-0 pa-0" style="width: 100%;">
                                    <v-list-tile
                                        v-for="(tipo_faturamento, index) in tipos_faturamento"
                                        :key="`${index}-tipos_faturamento`"
                                        class="mb-2"
                                    >
                                        <v-list-tile-avatar>
                                            <svg-filler
                                                v-if="tipo_faturamento.combustivel"
                                                :path="tipo_faturamento.combustivel.icone ? require(`@/assets/combs/${tipo_faturamento.combustivel.icone}.svg`) : require(`@/assets/combs/gas.svg`)"
                                                width="50px"
                                                height="50px"
                                                :fill="tipo_faturamento.combustivel.color"
                                            />
                                        </v-list-tile-avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-title>
                                                Referente a {{ tipo_faturamento.descricao }}
                                            </v-list-tile-title>
                                            <v-list-tile-sub-title v-if="tipo_faturamento.valor_vendido">
                                                Valor Vendido: {{ tipo_faturamento.valor_vendido | currency({ fractionCount: 2 }) }}
                                            </v-list-tile-sub-title>
                                            <v-list-tile-sub-title v-if="tipo_faturamento.valor_vendido">
                                                Quantidade Vendida: {{ tipo_faturamento.qtd_vendida }}
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-content>
                                            <v-list-tile-title>
                                                Valor da taxa {{ tipo_faturamento.valor | currency({ fractionCount: 2 }) }}
                                            </v-list-tile-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action class="justify-space-around d-inline">
                                            <v-tooltip bottom>
                                                <v-btn
                                                    slot="activator"
                                                    icon
                                                    class="mr-2"
                                                    @click="faturaSelecionada = fatura, step = 3"
                                                >
                                                    <v-icon color="error">delete</v-icon>
                                                </v-btn>
                                                <span>Apagar tipo de faturamento</span>
                                            </v-tooltip>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                                <v-flex xs12 class="ma-4">
                                    <v-divider></v-divider>
                                </v-flex>
                            </template>
                            <v-flex xs12>
                                <v-select
                                    block
                                    color="info"
                                    large
                                    outlined
                                    class="pa-3"
                                    label="Destino da fatura"
                                    :items="destinos_faturas"
                                    v-model="destino_fatura"
                                    item-text="text"
                                    item-value="value"
                                >
                                </v-select>
                            </v-flex>
                            <v-flex xs12>
                                <v-btn
                                    block
                                    color="info"
                                    :loading="loading"
                                    :disabled="faturas.length > 0"
                                    @click="cadastrarFaturaAutomaticamente"
                                    large
                                >
                                    Gerar Fatura
                                </v-btn>
                            </v-flex>
                            <h4 class="text-xs-right mt-4 mb-4" v-if="posto.taxa_por_combustivel">Taxa do posto: {{ posto.taxa_por_combustivel | currency({ fractionCount: 2 })  }}</h4>
                            <h4 class="text-xs-right mt-4 mb-4" v-if="precoSelecionando">Preço de {{ combustivelSelecionado.nome }} na bomba: {{ precoSelecionando | currency({ fractionCount: 2 }) }}</h4>
                            <v-btn
                                color="info"
                                class="mb-4"
                                @click="eh_automatico = !eh_automatico"
                                style="width: 100%;"
                                flat
                            >
                                {{ eh_automatico ? 'Gerar Manualmente' : 'Gerar Automaticamente' }}
                            </v-btn>
                        </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="3" class="justify-center ma-0 pa-0">
                        <v-layout justify-space-around wrap v-if="faturaSelecionada">
                            <v-flex xs12 v-if="faturaSelecionada.data_fatura">
                                <h3>Data: {{ faturaSelecionada.data_fatura  | formatDate('DD/MM/YYYY')  }}</h3>
                            </v-flex>
                            <v-flex xs12 v-if="faturaSelecionada.valor_faturamento">
                                <h3>Valor: {{ faturaSelecionada.valor_faturamento | currency({ fractionCount: 2 }) }}</h3>
                            </v-flex>
                            <v-flex xs12 v-if="faturaSelecionada.destino_fatura">
                                <h3>
                                    Destino:
                                    {{
                                    Number(faturaSelecionada.destino_fatura) === 1
                                        ? 'Apetrus'
                                        : Number(faturaSelecionada.destino_fatura) === 2
                                        ? 'Whitelabel'
                                        : Number(faturaSelecionada.destino_fatura) === 3
                                        ? 'Sindicato'
                                        : 'Indisponivel'
                                    }}
                                </h3>
                                </v-flex>
                                <v-flex xs12 class="mb-2">
                                    <v-btn
                                        color="info"
                                        @click="exportarFaturaSelecionada"
                                        small
                                        outlined
                                    >
                                        <v-icon left>mdi-file-excel</v-icon>
                                        Exportar para Excel
                                    </v-btn>
                                </v-flex>
                            <h3 v-if="faturaSelecionada.tipos_faturamento && faturaSelecionada.tipos_faturamento.length > 0" class="mt-4">Tipos de Cobranças</h3>
                            <v-list class="ma-0 pa-0" style="width: 100%;">
                                <v-list-tile
                                    v-for="(tipo_faturamento, index) in faturaSelecionada.tipos_faturamento"
                                    :key="`${index}-tipos_faturamento-list`"
                                    class="mb-2"
                                >
                                    <v-list-tile-avatar>
                                        <svg-filler
                                            v-if="tipo_faturamento.combustivel"
                                            :path="tipo_faturamento.combustivel.icone ? require(`@/assets/combs/${tipo_faturamento.combustivel.icone}.svg`) : require(`@/assets/combs/gas.svg`)"
                                            width="50px"
                                            height="50px"
                                            :fill="tipo_faturamento.combustivel.color"
                                        />
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            Referente a {{ tipo_faturamento.descricao }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title v-if="tipo_faturamento.valor_vendido">
                                            Valor Vendido: {{ tipo_faturamento.valor_vendido | currency({ fractionCount: 2 }) }}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title v-if="tipo_faturamento.valor_vendido">
                                            Quantidade Vendida: {{ tipo_faturamento.qtd_vendida }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                           <b>{{ tipo_faturamento.valor | currency({ fractionCount: 2 }) }}</b>
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-layout>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-card-text>
        <v-footer
          absolute
          dense
          style="background: transparent"
          v-show="step === 2"
        >
          <v-expand-transition>
            <v-toolbar dense>
              <v-spacer></v-spacer>
              <v-toolbar-title>
                Total {{ combustivelSelecionado ? `de ${combustivelSelecionado.nome.toLowerCase()} vendidos` : 'consumido' }}: {{ total_relatorio_compras | currency({ fractionCount: 2 }) }}
              </v-toolbar-title>
            </v-toolbar>
          </v-expand-transition>
        </v-footer>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import { VMoney } from 'v-money'
export default {
    directives: { money: VMoney },
    props: ['postoSelecionado'],
    data: () => ({
        dialogAtivo: false,
        posto: {},
        step: 1,
        destino_fatura: null,
        valor_total: '0,00',
        valor_vendas_combustivel: '0,00',
        valor_taxa: '0,00',
        valor_taxa_sugerido: 0,
        qtd_vendida: 0,
        qtd_sugerida: 0,
        faturaSelecionada: undefined,
        combustivelSelecionado: undefined,
        precoSelecionando: undefined,
        descricao: '',
        faturas: [],
        tipos_faturamento: [],
        eh_automatico: true,
        menuDataFatura: false,
        menuDataFim: false,
        data_inicio: null,
        data_fim: null,
        compras: [],
        precos_combustivel: [],
        pagination: {
            rowsPerPage: 5,
            page: 1
        },
        totalItems: 0,
        total_relatorio_compras: 0,
        money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            precision: 2,
            masked: false
        },
        alerta: undefined,
        tipo: 'error'
    }),
    watch: {
        async dialogAtivo (val) {
            if (val) {
                await this.carregarPosto()
                this.carregarFaturas()
                this.data_fim = moment().format('YYYY-MM-DD')
                const dataFimMoment = moment(this.data_fim, 'YYYY-MM-DD')
                this.data_inicio = dataFimMoment.subtract(1, 'months').format('YYYY-MM-DD')
            } else {
                this.faturaSelecionada = undefined
                this.step = 1
                this.faturas = []
                this.compras = []
                this.posto = {}
                this.totalItems = 0
                this.total_relatorio_compras = 0
                this.eh_automatico = true
                this.picker = null
                this.pagination = {
                    rowsPerPage: 5,
                    page: 1
                }
                this.valor_total = '0,00'
                this.valor_vendas_combustivel = '0,00'
                this.valor_taxa = '0,00'
                this.valor_taxa_sugerido = 0
                this.qtd_vendida = 0
                this.qtd_sugerida = 0
                this.combustivelSelecionado = undefined
                this.precoSelecionando = undefined
                this.descricao = ''
                this.tipos_faturamento = []
                this.menuDataFatura = false
                this.menuDataFim = false
                this.data_inicio = null
                this.data_fim = null
                this.precos_combustivel = []
            }
        },
        destino_fatura (val) {
                this.carregarCompras()
        },
        step (val) {
            if (val === 1) this.carregarFaturas()
            else if (val === 2) {
                this.carregarFaturas()
                this.carregarCompras()
                this.$store.dispatch('carregarCombustiveis')
                this.pegarPrecos()
            } else if (val === 3 && this.faturaSelecionada) {
                this.carregarDetalhes()
            }
        },
        combustivelSelecionado (val) {
            this.carregarCompras()
            if (val) {
                const temp = this.precos_combustivel.find((p) => p.combustivel.id_combustivel === val.id_combustivel)
                if (temp) {
                    this.precoSelecionando = temp.preco
                    this.qtd_sugerida = this.total_relatorio_compras / temp.preco
                }
            } else {
                this.precoSelecionando = undefined
                this.qtd_sugerida = 0
            }
        },
        total_relatorio_compras (val) {
            if (val && this.precoSelecionando) {
                this.qtd_sugerida = val / this.precoSelecionando
            }
        },
        qtd_sugerida (val) {
            if (val && this.precoSelecionando) {
                this.valor_taxa_sugerido = (val / this.precoSelecionando).toFixed(3)
            } else this.valor_taxa_sugerido = 0
        },
        data_inicio (val) {
            if (val) {
                this.carregarFaturas()
                this.carregarCompras()
            }
        },
        data_fim (val) {
            if (val) {
                this.carregarFaturas()
                this.carregarCompras()
            }
        }
    },
    computed: {
        titulo () {
            switch (this.step) {
                case 1: return 'FATURAS DO POSTO'
                case 2: return this.faturaSelecionada ? 'EDITAR FATURA' : 'GERAR FATURA'
                case 3: return 'VISUALIZAR FATURA'
                default: return 'INVÁLIDO'
            }
        },
        loading () {
            return this.$store.getters.loading
        },
        combustiveis () {
            return this.$store.getters.combustiveis
        },
        destinos_faturas () {
            const posto = this.posto
            if (!posto) return []

            const destinos = []

            const isSimultaneo = !!posto.is_simultaneo
            const isWhiteLabel = !!posto.is_white_label
            const temSindicato = !!posto.rede_sindicato

            if (isSimultaneo || (!isWhiteLabel && !temSindicato)) {
                destinos.push({ text: 'Apetrus', value: 1 })
            }

            if (isWhiteLabel) {
                destinos.push({ text: 'Whitelabel', value: 2 })
            }

            if (temSindicato) {
                destinos.push({ text: 'Sindicato', value: 3 })
            }

            return destinos
        }
    },
    methods: {
        formatarValor (valor) {
            if (!valor) return 0
            if (isNaN(parseFloat(valor))) return 0
            return Number(valor.replaceAll('.', '').replace(',', '.'))
        },
        adicionarTipoFaturamento () {
            if (!this.valor_taxa) {
                this.ativaAlerta('Valor da taxa inválido.', 'error')
                return
            }
            if (!this.descricao) {
                this.ativaAlerta('Descrição não informada.', 'error')
                return
            }
            if (this.combustivelSelecionado) {
                const existe = !!this.tipos_faturamento.find((tipo) => (tipo.combustivel && tipo.combustivel.id_combustivel === this.combustivelSelecionado.id_combustivel) || tipo.combustivel)
                if (existe) {
                    this.ativaAlerta('Um tipo de faturamento com esse combustível já foi inserido.', 'error')
                    return
                }
            }
            this.tipos_faturamento.push({
                descricao: this.descricao,
                qtd_vendida: this.qtd_vendida ? this.qtd_vendida : null,
                combustivel: this.combustivelSelecionado ? this.combustivelSelecionado : null,
                valor_vendido: this.valor_vendas_combustivel ? this.formatarValor(this.valor_vendas_combustivel) : null,
                valor: this.formatarValor(this.valor_taxa)
            })
            this.descricao = undefined
            this.qtd_vendida = undefined
            this.combustivelSelecionado = undefined
            this.valor_vendas_combustivel = '0,00'
            this.valor_taxa = '0,00'
        },
        ativaAlerta (alerta, tipo) {
            this.alerta = alerta
            this.tipo = tipo
            const interval = setInterval(() => {
                this.alerta = undefined
                clearInterval(interval)
            }, 5000)
        },
        carregarFaturas () {
            const data = {
                method: 'GET',
                parametros: {
                    posto: this.postoSelecionado.cnpj
                }
            }
            if (this.step === 2) {
                if (this.data_fim) data.parametros.data_fim = this.data_fim
                if (this.data_inicio) data.parametros.data_inicio = this.data_inicio
            }
            this.$store.dispatch('gerenciarFaturas', data).then(json => {
                this.faturas = json
            })
        },
        deletarFatura (fatura) {
            if (this.loading) return
            this.$store.dispatch('gerenciarFaturas', {
                method: 'DELETE',
                corpo: {
                    id_fatura: fatura.id
                }
            }).then(() => {
                this.ativaAlerta('Fatura foi deletada com sucesso.', 'success')
                this.carregarFaturas()
            })
        },
        cadastrarFaturaAutomaticamente () {
            this.$store.dispatch('gerenciarFaturas', {
                method: 'POST',
                corpo: {
                    posto: this.postoSelecionado.cnpj,
                    eh_automatico: this.eh_automatico,
                    valor_faturamento: this.formatarValor(this.valor_total),
                    tipos_faturamento: this.tipos_faturamento,
                    data_inicio: this.data_inicio,
                    data_fim: this.data_fim,
                    destino_fatura: this.destino_fatura
                }
            }).then(() => {
                this.step = 1
                this.combustivelSelecionado = undefined
                this.valor_taxa = '0,00'
                this.valor_taxa_sugerido = 0
                this.valor_total = '0,00'
                this.valor_vendas_combustivel = '0,00'
                this.qtd_sugerida = 0
                this.qtd_vendida = 0
                this.eh_automatico = true
                this.tipos_faturamento = []
                this.ativaAlerta('Fatura foi cadastrada com sucesso.', 'success')
                this.carregarFaturas()
            })
        },
        carregarCompras (btn) {
            let data = {
                posto: this.postoSelecionado.cnpj,
                confirmado: true,
                cancelada: false
            }
            data.page = btn ? this.pagination.page : 1
            if (this.data_inicio) {
                data.data_compra__gte = this.data_inicio
            }
            if (this.data_fim) {
                data.data_compra__lte = this.data_fim
            }
            if (this.combustivelSelecionado) {
                data.combustivel = this.combustivelSelecionado.id_combustivel
            }
            if (this.destino_fatura === 1) {
                data.is_white_label = false
                data['rede_sindicato__isnull'] = true
            }
            if (this.destino_fatura === 2) {
                data.is_white_label = true
                data['rede_sindicato__isnull'] = true
            }
            if (this.destino_fatura === 3) {
                data.rede_sindicato = this.posto.rede_sindicato
                data.is_white_label = true
            }
            this.$store.dispatch('pegarCompras', data)
                .then(json => {
                    this.totalItems = json.count
                    this.total_relatorio_compras = json.results.valor_total
                })
        },
        pegarPrecos () {
            this.$store.dispatch('pegarPrecos', this.posto.cnpj).then(json => {
                this.precos_combustivel = json
            })
        },
        carregarDetalhes () {
            this.$store.dispatch('detalhesFaturamento', this.faturaSelecionada.id).then(json => {
                console.log(json)
                this.faturaSelecionada = json
            })
        },
        carregarPosto () {
            this.$store.dispatch('detalhesPosto', this.postoSelecionado.cnpj).then(json => {
                this.posto = json
            })
        },
        exportarFaturaSelecionada () {
            if (this.faturaSelecionada && this.faturaSelecionada.id) {
                this.$store.dispatch('exportarFaturamento', this.faturaSelecionada.id)
            }
        }
    }
}
</script>
